import { jsx as _jsx } from "react/jsx-runtime";
import ROUTE_PATHS from './paths';
import Home from '../pages/Home';
import About from '../pages/About/About';
import Products from '../pages/Products';
import ProductDetail from '../pages/Products/ProductDetail';
import Contact from '../pages/Contact/Contact';
import RegenerativeMedicine from '../pages/RegenerativeMedicine';
import Solutions from '../pages/Solutions';
import OrderDetails from '../pages/OrderDetails';
import ShoppingCart from '../pages/ShoppingCart';
import OrderSuccess from '../pages/OrderSuccess';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsAndConditions from '../pages/TermsAndConditions';
import ReturnPolicy from '../pages/ReturnPolicy';
import CreateAccount from '../pages/Account/CreateAccount';
import AccountSuccess from '../pages/Account/AccountSuccess';
import CreateClinic from '../pages/Account/CreateClinic';
import Login from '../pages/Account/Login';
import ForgotPassword from '../pages/Account/ForgotPassword';
import ResetPassword from '../pages/Account/ResetPassword';
import ClinicSuccess from '../pages/Account/ClinicSuccess';
import EmailSuccess from '../pages/Account/EmailSuccess';
import ClinicApproval from '../pages/Account/ClinicApproval/ClinicApproval';
import EmailVerificationSuccess from '../pages/Account/EmailVerificationSuccess';
import Admin from '../pages/Admin';
import ClinicsAdmin from '../pages/Admin/Clinics';
import ClinicCreate from '../pages/Admin/ClinicCreate';
import ClinicDetails from '../pages/Admin/ClinicDetails';
import ClinicUsers from '../pages/Admin/ClinicUsers';
import AccountClinicDetails from "../pages/Account/ClinicDetails";
import UsersAdmin from '../pages/Admin/Users';
import AdminOrderDetails from '../pages/Admin/OrderDetails';
import OrderBatching from '../pages/Admin/OrderBatching';
import ProductsAdmin from '../pages/Admin/Products';
import ProductDetails from '../pages/Admin/ProductDetails';
import CouponCodes from '../pages/Admin/CouponCodes';
import PromoCodeDetails from '../pages/Admin/PromoCodeDetails';
import PromoCodeUsages from '../pages/Admin/PromoCodeUsages';
import CorporateGroups from '../pages/Admin/CorporateGroups';
import SalesReps from '../pages/Admin/SalesReps';
import ProductCategories from '../pages/Admin/ProductCategories';
import ShippingMethods from '../pages/Admin/ShippingMethods';
import ManufacturerShipping from '../pages/Admin/ManufacturerShipping';
import BioPage from '../pages/Admin/BioPage';
import ProtectedRoute from '../components/ProtectedRoute';
import Orders from '../pages/Admin/Orders';
const ROUTE_CONFIGS = [
    {
        path: ROUTE_PATHS.home,
        label: 'Home',
        element: _jsx(Home, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.products,
        label: 'Products',
        element: _jsx(Products, {}),
        showInMobile: true,
        mobileOrder: 1,
        childLinks: [
            {
                path: ROUTE_PATHS.products,
                label: 'All Products',
                element: _jsx(Products, {}),
                showInMobile: true,
                mobileLabel: 'Shop',
            },
            {
                path: `${ROUTE_PATHS.products}?category=regenerative-medicine`,
                label: 'Regenerative Medicine',
                element: _jsx(Products, {}),
                showInMobile: false,
                requireAuth: true,
            },
            // {
            //   path: ROUTE_PATHS.solutions,
            //   label: 'Solutions',
            //   element: <Solutions />,
            //   showInMobile: false,
            //   requireAuth: true,
            // },
        ],
    },
    {
        path: ROUTE_PATHS.productDetail,
        label: 'Product Detail',
        element: _jsx(ProductDetail, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.about,
        label: 'About Us',
        element: _jsx(About, {}),
        showInMobile: true,
        mobileOrder: 2,
    },
    {
        path: ROUTE_PATHS.contact,
        label: 'Contact',
        element: _jsx(Contact, {}),
    },
    {
        path: ROUTE_PATHS.regenerativeMedicine,
        label: 'Regenerative Medicine',
        element: _jsx(RegenerativeMedicine, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.solutions,
        label: 'Solutions',
        element: _jsx(Solutions, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.orderDetails,
        label: 'orderDetails',
        element: _jsx(OrderDetails, {}),
        excludeFromMenu: true,
        showInMobile: true,
        mobileLabel: 'My Orders',
        mobileOrder: 3,
        requireAuth: true,
    },
    {
        path: ROUTE_PATHS.shoppingCart,
        label: 'shoppingCart',
        element: _jsx(ShoppingCart, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.orderSuccess,
        label: 'orderSuccess',
        element: _jsx(OrderSuccess, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.privacyPolicy,
        label: 'privacyPolicy',
        element: _jsx(PrivacyPolicy, {}),
        excludeFromMenu: true,
        showInMobile: true,
        mobileLabel: 'Privacy Policy',
        mobileOrder: 4,
    },
    {
        path: ROUTE_PATHS.termsAndConditions,
        label: 'termsAndConditions',
        element: _jsx(TermsAndConditions, {}),
        excludeFromMenu: true,
        showInMobile: true,
        mobileLabel: 'Terms And Conditions',
        mobileOrder: 5,
    },
    {
        path: ROUTE_PATHS.returnPolicy,
        label: 'returnPolicy',
        element: _jsx(ReturnPolicy, {}),
        excludeFromMenu: true,
        showInMobile: true,
        mobileLabel: 'Return Policy',
        mobileOrder: 6,
    },
    {
        path: ROUTE_PATHS.createAccount,
        label: 'createAccount',
        element: _jsx(CreateAccount, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.accountSuccess,
        label: 'accountSuccess',
        element: _jsx(AccountSuccess, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.createClinic,
        label: 'createClinic',
        element: _jsx(CreateClinic, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.clinicDetails,
        label: 'clinicDetails',
        element: _jsx(AccountClinicDetails, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.clinicOrders,
        label: 'clinicOrders',
        element: _jsx(Orders, { clinicView: true }),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.clinicOrderDetails,
        label: 'clinicOrderDetails',
        element: _jsx(AdminOrderDetails, { clinicView: true }),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.login,
        label: 'login',
        element: _jsx(Login, {}),
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.forgotPassword,
        label: 'forgotPassword',
        element: _jsx(ForgotPassword, {}),
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.resetPassword,
        label: 'resetPassword',
        element: _jsx(ResetPassword, {}),
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.clinicSuccess,
        label: 'clinicSuccess',
        element: _jsx(ClinicSuccess, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.emailSuccess,
        label: 'emailSuccess',
        element: _jsx(EmailSuccess, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.clinicApproval,
        label: 'clinicApproval',
        element: _jsx(ClinicApproval, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.verifyEmail,
        label: 'verifyEmail',
        element: _jsx(EmailVerificationSuccess, {}),
        excludeFromMenu: true,
    },
    {
        path: ROUTE_PATHS.admin,
        label: 'Admin',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(Admin, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminClinics,
        label: 'Clinics',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ClinicsAdmin, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminClinicCreate,
        label: 'Create Clinic',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ClinicCreate, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminClinicDetails,
        label: 'Clinic Details',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ClinicDetails, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminUsers,
        label: 'Users',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(UsersAdmin, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminClinicUsers,
        label: 'Clinic Users',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ClinicUsers, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminOrders,
        label: 'Orders',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(Orders, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminOrderDetails,
        label: 'Order Details',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(AdminOrderDetails, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminOrderBatching,
        label: 'Order Batching',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(OrderBatching, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminPromoCodes,
        label: 'Promo Codes',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(CouponCodes, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminPromoCodeUsages,
        label: 'Promo Code Usages',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(PromoCodeUsages, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminCorporateGroups,
        label: 'Corporate Groups',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(CorporateGroups, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminSalesReps,
        label: 'Sales Reps',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(SalesReps, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminProductCategories,
        label: 'Product Categories',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ProductCategories, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminShippingMethods,
        label: 'Shipping Methods',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ShippingMethods, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminManufacturerShipping,
        label: 'Manufacturer Shipping',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ManufacturerShipping, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminProducts,
        label: 'Products',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ProductsAdmin, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminProductNew,
        label: 'New Product',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ProductDetails, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminProductDetails,
        label: 'Product Details',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(ProductDetails, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminPromoCodeNew,
        label: 'New Promo Code',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(PromoCodeDetails, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminPromoCodeDetails,
        label: 'Promo Code Details',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(PromoCodeDetails, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
    {
        path: ROUTE_PATHS.adminBioPage,
        label: 'Bio Page',
        element: (_jsx(ProtectedRoute, { requireAdmin: true, children: _jsx(BioPage, {}) })),
        requireAuth: true,
        excludeFromMenu: true,
        excludeNavigation: true,
        excludeFooter: true,
    },
];
export default ROUTE_CONFIGS;
